import { GET } from "../../../helpers/restFunction";

const GetBankDetails = async (userId: string) => {
  const path = `/cad/${userId}/cad_bank_details`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
export default GetBankDetails;
